import React, { useEffect, useState } from 'react';
import './App.css';
import SimpleModIQVisualizer from './SimpleModIQVisualizer';
import PasswordGate from './components/PasswordGate';

// Get project ID from URL parameters
const getProjectIdFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('project');
};

// Simple Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#fee', 
          color: '#d00',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h1>Something went wrong</h1>
          <p>Error: {this.state.error?.message}</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#d00',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  const [initialProjectId] = useState(() => getProjectIdFromUrl());
  
  // Update URL when project changes (for sharing)
  const handleProjectChange = (projectId) => {
    if (projectId) {
      const url = new URL(window.location.href);
      url.searchParams.set('project', projectId);
      window.history.replaceState({}, '', url.toString());
    } else {
      const url = new URL(window.location.href);
      url.searchParams.delete('project');
      window.history.replaceState({}, '', url.toString());
    }
  };

  return (
    <ErrorBoundary>
      <PasswordGate>
        <div className="App">
          <SimpleModIQVisualizer 
            initialProjectId={initialProjectId}
            onProjectChange={handleProjectChange}
          />
        </div>
      </PasswordGate>
    </ErrorBoundary>
  );
}

export default App;